import React, { memo, useCallback } from 'react';
import { useAppSelector } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import SectionHeader from './SectionHeader';
import InvestActivityRow from './InvestActivityRow';
import { selectFirstThreePendingActivities } from '../reducers/selectors';
const PendingActivitiesSection = () => {
    const navigation = useMainStackNavigation();
    const { activities, canSeeAll, activityLength } = useAppSelector(selectFirstThreePendingActivities);
    const onSeeMorePress = useCallback(() => {
        navigation.navigateDeprecated('InvestNewActivityScreen');
    }, []);
    if (!activities?.length)
        return null;
    return (<>
      <SectionHeader title="Pending" onSeeMorePress={canSeeAll ? onSeeMorePress : undefined}/>
      {activities.map((activity, index) => (<InvestActivityRow item={{ ...activity, isFirstInSection: index === 0, isLastInSection: index === activityLength - 1 }} key={activity.id}/>))}
    </>);
};
export default memo(PendingActivitiesSection);
